
/**
 * Module dependencies.
 */

import reject from 'lodash/reject';

/**
 * Export `effects`.
 */

export const effects = {
  antislip: 'antislip',
  ecotiles: 'ecotiles',
  marble: 'marble',
  metalic: 'metalic',
  relief: 'relief',
  rustic: 'rustic',
  signature: 'signature',
  stone: 'stone',
  unicolor: 'unicolor',
  urban: 'urban',
  wood: 'wood'
} as const;

/**
 * Export `availableFilterEffects`.
 */

export const availableFilterEffects = reject(effects, effect => {
  return effect === effects.antislip;
});
